import { Booking } from '../models/booking.model';
import { ListItem } from '../models/ListItem';
import GenericService from './genericService';
import { httpService } from './httpService';

class BookingService extends GenericService<Booking, ListItem> {
  constructor() {
    super('/api/Booking');
  }
  async getAllB2BUserBookings(normalize = true, toast = false): Promise<Booking[]> {
    return await httpService.get<Booking[]>(`/api/Booking/GetAllB2BUserBookings`, undefined, { unwrap: true, normalize, toast, });
  }

  async updateBookingStatus(bookingId: number, roomId: number, status: string, toast = true): Promise<boolean> {
    try {
      console.log('BookingService: Calling API with:', {
        url: `/api/Booking/UpdateStatus/${bookingId}/${roomId}`,
        payload: { status },
        bookingId,
        roomId,
        status
      });
      
      const response = await httpService.put(`/api/Booking/UpdateStatus/${bookingId}/${roomId}`, { status }, undefined, { toast });
      console.log('BookingService: API response:', response);
      return true;
    } catch (error) {
      console.error('BookingService: Error updating booking status:', error);
      return false;
    }
  }

  async confirmRoomReservation(roomId: number, userId: string, toast = true): Promise<boolean> {
    try {
      console.log('BookingService: Confirming room reservation:', {
        url: `/api/ReservationShortlist/ConfirmRoomReservation/${roomId}`,
        roomId,
        userId
      });
      
      const response = await httpService.put(
        `/api/ReservationShortlist/ConfirmRoomReservation/${roomId}`, 
        { 
          status: 'Confirmed',
          userId: userId 
        }, 
        undefined, 
        { toast }
      );
      console.log('BookingService: Confirm room response:', response);
      return true;
    } catch (error) {
      console.error('BookingService: Error confirming room reservation:', error);
      return false;
    }
  }
}
export const bookingService = new BookingService();